import React from "react";
import { Button } from "@fluentui/react-components";
import styles from "./ActionButton.module.css";

interface Props {
  /** Main label displayed on the button */
  children: React.ReactNode;
  /** Optional icon component (must accept `color` prop) */
  icon?: React.ComponentType<{ color?: string }>;
  /** Fired on click */
  onClick: () => void;
  disabled?: boolean;
  /** Hover callbacks (optional, useful for Lottie / confetti etc.) */
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  /** If the pointer is “inside” (used for icon colour swap) */
  isInside?: boolean;
  /** Extra classes / inline style passthroughs */
  className?: string;
  style?: React.CSSProperties;
}

export const ActionButton = ({ children, icon: Icon, onClick, disabled, onMouseEnter, onMouseLeave, isInside = false, className, style }: Props) => {
  const iconColour = isInside ? "#002664" : "#ffffff";

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`${styles.actionBtn} ${className ?? ""}`}
      style={style}
    >
      {children}

      {Icon && (
        <span className={styles.iconWrap}>
          <Icon color={iconColour} />
        </span>
      )}
    </Button>
  );
};
